"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function removeElement(domElement, compositeId, component) {
    component.subcacheClear(compositeId);
    domElement.parentNode.removeChild(domElement);
    return domElement;
}
exports.default = removeElement;
//# sourceMappingURL=removeElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/renderers/dom/removeElement.js
// module id = 156
// module chunks = 35783957827783 127651196306611 162898551421021